import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-24 md:py-32 text-center">
        <p className="font-heading text-7xl md:text-9xl font-black text-background-200 select-none">
          404
        </p>
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-6">
          页面不存在
        </h1>
        <p className="text-sm text-foreground-500 mt-3">
          您访问的页面可能已被移除或链接有误：{" "}
          <span className="text-foreground-700">{location.pathname}</span>
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-secondary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-secondary-600 transition-colors"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link
            to="/search"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-300 text-sm text-foreground-700 whitespace-nowrap hover:border-secondary-400 hover:text-secondary-700 transition-colors"
          >
            <i className="ri-search-line" />
            去搜索文章
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}